import { render, staticRenderFns } from "./appSpinner.vue?vue&type=template&id=52914f19"
import script from "./appSpinner.vue?vue&type=script&lang=js"
export * from "./appSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports